/* eslint-disable no-self-compare */
import React, { FC, useEffect, useState } from "react";
import { MdOutlineErrorOutline } from "react-icons/md";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ViewJobModal from "../../../components/ModalComponents/ViewJobModal";
import { EntriesPerPage, Search, TableFetch, TableProgressBar } from "../../../components/TableOptions";
import Pagination from "../../../components/Pagination";
import moment from "moment";
import swal from 'sweetalert';
import { reset } from "../../../features/Job/jobSlice";
import { useAppDispatch } from "../../../useStore";
import { Toaster } from "react-hot-toast";
import XLoader from "../../../components/XLoader";

interface Props {
  data: any;
  pageHeader?: any;
  headerTitles: Array<string>;
  setActive: any;
  active: any;
  isLoading: any;
  message: any;
  isError: any;
  setJobLenght: any;
}

const ActiveJobTable: FC<Props> = ({
  pageHeader,
  headerTitles,
  data,
  message,
  isError,
  isLoading,
  setJobLenght
}) => {
  const dispatch = useAppDispatch();

  const [show, setShow] = useState<any>(false);
  const [index, setIndex] = useState<any>("");
  const [datas, setDatas] = useState([]);
  const [searchItem, setSearchItem] = useState("");

  const [entriesperpage, setEntriesPerPage] = useState(() => {
    return "8";
  });





  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])



  useEffect(() => {
    const result = data?.filter((item: any) =>
      item?.jobLocation?.toLowerCase()?.includes(searchItem));

    setDatas(result);
    setJobLenght(result?.length)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchItem, setJobLenght]);

  const [displayData, setDisplayData] = useState([]);


  return (
    <div>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          error: {
            duration: 20000,
          },
        }}
      />
      <section className="md-ui component-data-table">
        <header className="main-table-header">
          <div className="main-table-search-container">
            <h1 className="table-header--title">{pageHeader}</h1>
            <Search
              searchItem={searchItem}
              setSearchItem={setSearchItem}
              placeholder={pageHeader}
            />
            <EntriesPerPage
              data={datas}
              entriesperpage={entriesperpage}
              setEntriesPerPage={setEntriesPerPage}
            />
            <span className="table-header--icons">
              <Link to="/JobProfileContainer" className="applicant-btn">
                <Button className="view-HIRED-profile">New Job</Button>
              </Link>
            </span>
          </div>
        </header>
        {isLoading && <XLoader isLoading={isLoading} />}
        <div className="main-table-wrapper">
          <table className="main-table-content">
            <thead className="data-table-header">
              <tr className="data-table-row">
                {headerTitles?.map((title, i) => (
                  <td className="table-datacell datatype-string headerTitles"
                    key={i}>
                    {title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody className="data-table-content">
              {isLoading ? (
                <TableFetch colSpan={12} />
              ) : displayData?.length === 0 ||
                displayData?.length === undefined ? (
                <tr>
                  <td className="table-msg" colSpan={12}>
                    <MdOutlineErrorOutline size={75} />
                    <p>No Record found!</p>
                  </td>
                </tr>
              ) : (
                displayData?.map((row: any, i: any) => (
                  <>
                    <ViewJobModal
                      show={show}
                      setShow={setShow}
                      id={index}
                      setInputs={undefined}
                    />

                    <tr
                      className="data-table-row"
                      key={i}
                      onClick={() => {
                        setShow(true);
                        setIndex(row?.id);
                      }}
                    >
                      <td className="table-datacell datatype-string">
                        <div className="dropdown">
                          <button className="dropbtn">
                            <MoreHorizIcon />
                          </button>
                        </div>
                      </td>

                      <td className="table-datacell datatype-numeric">
                        {row?.numberOfOpenings}
                      </td>

                      <td className="table-datacell datatype-numeric">
                        {moment(row?.openingDate).format("DD-MMMM-YYYY")}
                      </td>

                      <td className="table-datacell datatype-numeric">
                        {moment(row?.expiryDate).format("DD-MMMM-YYYY")}
                      </td>

                      <td className="table-datacell datatype-numeric">
                        {row?.employmentType}
                      </td>

                      <td className="table-datacell datatype-numeric">
                        {row?.team}
                      </td>

                      <td className="table-datacell datatype-numeric">
                        {row?.jobLocation}
                      </td>

                      <td className="table-datacell datatype-string">
                        {row?.workplaceType}
                      </td>

                      <td className="table-datacell datatype-string">
                        <div className="table-collection">
                          <span className="table-name-span1">
                            <ol className="table-name-span1-ol">
                              <li>{row?.recruiterTagged}</li>
                              <li>{row.email}</li>
                            </ol>
                          </span>
                        </div>
                      </td>

                      <td className="table-datacell datatype-string">
                        <div className="table-collection">
                          {/* <span className="table-name-span">
                            <img
                              src={Image1}
                              alt="Logo"
                              className="table-span-image"
                            />
                          </span> */}
                          <span className="table-name-span1">
                            <ol className="table-name-span1-ol">
                              <li>{row?.hiringManager}</li>
                              <li>{row?.email}</li>
                            </ol>
                          </span>
                        </div>
                      </td>

                      <td className="table-datacell datatype-numeric"> </td>
                    </tr>
                  </>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="table-footer">
          <div>
            <Pagination
              setDisplayData={setDisplayData}
              data={datas}
              entriesperpage={entriesperpage}
              Total={"Active Job"}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ActiveJobTable;

